export const categories = [
  {
    slug: 'qinggan-lianjie',
    name: '情感连接',
    description: '提升伴侣间情感沟通与连接技巧',
    icon: 'ri-heart-line',
    color: 'primary',
  },
  {
    slug: 'xingjiankang-zhishi',
    name: '性健康知识',
    description: '科学专业的性健康科普内容',
    icon: 'ri-mental-health-line',
    color: 'secondary',
  },
  {
    slug: 'hunyin-jingying',
    name: '婚姻经营',
    description: '婚姻关系维护与幸福秘诀',
    icon: 'ri-home-heart-line',
    color: 'accent',
  },
  {
    slug: 'liangxing-goutong',
    name: '两性沟通',
    description: '改善伴侣沟通方式与技巧',
    icon: 'ri-chat-heart-line',
    color: 'primary',
  },
  {
    slug: 'xinli-jiankang',
    name: '心理健康',
    description: '亲密关系中的心理调适与成长',
    icon: 'ri-brain-line',
    color: 'secondary',
  },
  {
    slug: 'qinzi-jiaoyu',
    name: '亲子关系',
    description: '家庭关系与亲子教育指南',
    icon: 'ri-parent-line',
    color: 'accent',
  },
];

export const getCategoryBySlug = (slug: string) => {
  return categories.find((c) => c.slug === slug) || null;
};